import $ from "jquery";
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import init from '../AccessControl/Check';


import DatePickerV2 from "../../../components/Date/DatePicker-v2";
import DatePickerRange from "../../../components/Date/DatePickerRange";
import moment from "moment";
import PostLoginGetApi from "../../../components/Api/PostLoginGetApi";
import { CSVLink } from "react-csv";
import number_format from "../../../components/Constants/NumberFormat"; 
import Popup from "../../../components/Popup";
import { ReactComponent as CloseBtn } from './../../../assets/icons/close.svg';
import PostLoginPostApi from "../../../components/Api/PostLoginPostApi";
import { toast } from "react-toastify";
import UserBasicInfoQRContext from "../../../components/Context/UserBasicInfoQRContext";
import { MAX_UPLOAD_FILE_SIZE } from "../../../components/Constants/FileUpload";


const SettlementComplete = () => {

    const pageName = "Settlement Complete";
    const isAccess = init(pageName);

    const companyProfile = useContext(UserBasicInfoQRContext);

    var setDatePicker = () => {
        $("#date-div").hide();
        $("#date-range-div").hide();
    
        $("#fromDate, #toDate, #singleDatePicker").datepicker('setDate', null);
    
    
        var v = $("#date-range-data").val();
        if (v === "custom") {
            $("#date-range-div").show();
        }
        else if (v === "all") {
            $("#date-div").attr("style", "display:flex");
        }
    }

    
    const [orderList, setOrderList] = useState([]);
    const [isFilter, setIsFilter] = useState(false);
    const [reqParam, setReqParam] = useState({
        page: 1
    })

    const filterClick = () => {
        $("#filter-toggle-icon").toggleClass("rotate-180");
        $(".custom-btn.filter").toggleClass("active");

        $("#filter-div").toggleClass("need-without-shadow");
        $("#filter-div").toggleClass("no-need-without-shadow");
    }

    const [refreshCounter, setRefreshCounter] = useState(0);
    useEffect(() => {
        PostLoginGetApi("settlement/ready-for-process-complete", reqParam, 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setOrderList(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        });

    }, [isFilter, reqParam, refreshCounter]);


    const [bankList, setBankList] = useState([]);
    useEffect(()=>{
        // Bank List
        PostLoginGetApi("banks", "", 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setBankList(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    }, []);

    const filter = () => {
        
        reqParam.page = 1;
        
        reqParam.service_type = $("#service_type").val() ?? "";
        reqParam.code = $("#search-by-transaction-id").val() ?? "";

        // Date Filter
        let from = "", end = "";
        if ($("#date-range-data").val() === "custom") {
            from = $("#fromDate").val();
            end = $("#toDate").val();

            if (from.length === 0 || end.length === 0) {
                from = "";
                end = "";
            }
            else {
                let nextDate = new Date(end);
                nextDate.setDate(nextDate.getDate());
                nextDate = nextDate.getFullYear() + "-" + (nextDate.getMonth() + 1) + "-" + nextDate.getDate();
                nextDate = moment(nextDate).format("YYYY-MM-DD");
                end = nextDate;
            }
        }
        else if ($("#date-range-data").val() === "all") {
            const singleDatePicker = $("#singleDatePicker").val();
            if (singleDatePicker.length !== 0) {
                let nextDate = new Date(singleDatePicker);
                nextDate.setDate(nextDate.getDate());
                nextDate = nextDate.getFullYear() + "-" + (nextDate.getMonth() + 1) + "-" + nextDate.getDate();
                nextDate = moment(nextDate).format("YYYY-MM-DD");

                from = singleDatePicker;
                end = nextDate;
            }
        }


        reqParam.from = from;
        reqParam.end = end;

        setReqParam({ ...reqParam });
        setIsFilter(true);
    }

    const resetFilterData = () => {

        $("#date-range-data").val("custom");
        $("#fromDate, #toDate, #singleDatePicker").datepicker('setDate', null);
        $("#to-date-picker").val("");


        $("#service_type").val('all')
        $("#search-by-transaction-id").val("");


        $("#date-div").hide();
        $("#date-range-div").show();


        filter();
        setIsFilter(false);
    }

    const checkBoxEnable = (id) => {
        let status = $("#cb_order_" + id).prop("checked");
        if( status ) {
            $("#cb_order_" + id).prop("checked", false);
            checkStatusTopProcessButton();
            return;
        }

        $("#cb_order_" + id).prop("checked", true);
        checkStatusTopProcessButton();
    }

    const selectAllCheckBox = () => {
        if( $("#all_cb_select").prop("checked") ) {
            $(".order_cb").prop("checked", true);
            checkStatusTopProcessButton();
            return;
        }
        
        $(".order_cb").prop("checked", false);
        checkStatusTopProcessButton();
    }

    const checkBoxEnable2 = (id) => {
        setTimeout(()=>{
            let status = $("#cb_order_" + id).prop("checked");
            if( status ) {
                $("#cb_order_" + id).prop("checked", false);
                checkStatusTopProcessButton();
                return;
            }

            $("#cb_order_" + id).prop("checked", true);
            checkStatusTopProcessButton();
        }, 100);
    }

    const checkStatusTopProcessButton = () => {
        setTimeout(()=>{ 
            let ck_box = $('input[type="checkbox"][name="order_cb"]:checked').length;
            if( ck_box > 0) {
                $("#top_process_btn").html(`Complete Settlement ${ck_box} selected order`);
                $("#top_process_btn").show();
                $(".process_button_single").attr("disabled",true);
                return;
            }
            
            $(".process_button_single").attr("disabled",false);
            $("#top_process_btn").hide();
            $("#top_process_btn").html(`Process`);
        }, 300);
    }

    const [processData, setProcessData] = useState({
        id: [],
        type: [],
        count: 0,
        order_amount: 0,
        settlement_fee: 0,
        settled_amount: 0,
        data: [],
        data2: []
    });

    
    const [showProcessDialog, setShowProcessDialog] = useState(false);
    const processDialog = () => {
        let cb = $('input[type="checkbox"][name="order_cb"]');
        let c = 0;
        
        let dataArr = [];
        let dataArr2 = [];
        let ids = [];
        let types = [];
        var total = 0;
        var fee = 0;
        var payable = 0;

        cb.each((i)=>{
            if( cb.eq(i).prop("checked") ) {

                ids.push($(".order_id").eq(i).val());
                types.push($(".order_type").eq(i).val());
                total += parseFloat($(".order_amount").eq(i).val() ?? 0);
                fee += parseFloat($(".order_fee").eq(i).val() ?? 0);

                if($(".settlement_on").eq(i).val() === "trade_price") {
                    payable += parseFloat($(".trade_price").eq(i).val() ?? 0);
                }
                else {
                    payable += parseFloat($(".order_payable").eq(i).val() ?? 0);
                }



                dataArr2.push($(".order_transaction_no").eq(i).val());

                dataArr.push([
                    $(".order_transaction_no").eq(i).val(), 
                    parseInt($(".order_id").eq(i).val()), 
                    $(".order_type").eq(i).val(), 
                    parseFloat($(".order_amount").eq(i).val() ?? 0),
                    parseFloat($(".order_fee").eq(i).val() ?? 0),
                    parseFloat($(".order_payable").eq(i).val() ?? 0),
                    $(".order_quantity").eq(i).val(),
                    parseFloat($(".trade_price").eq(i).val() ?? 0),
                    $(".settlement_on").eq(i).val(),
                ]);

                c++;
            }
        });


        setProcessData({...processData, id: ids, type: types, count: c, order_amount: total, settlement_fee: fee, settled_amount: payable, data: dataArr, data2: dataArr2});
        setShowProcessDialog(true);
    }

    const processDialogSingle = (id, total, fee, payable, type, bookingCode, quantity, settlement_on, trade_price) => {
        let dataArr = [];
        dataArr.push([bookingCode, id, type, total, fee, payable, quantity, settlement_on, trade_price]);


        let settled_amount = payable;
        if( settlement_on === "trade_price" ) { 
            if( trade_price > 0 ) {
                settled_amount = trade_price;
            }
        }
        setProcessData({...processData, count: 1, id: [id], type: [type], order_amount: total, settlement_fee: fee, settled_amount: settled_amount, data: 
            dataArr, data2:[bookingCode]});
        setShowProcessDialog(true);
    }


    const closeProcessBox = () => {
        $('input[type="checkbox"][name="order_cb"]').prop("checked",false);
        $('#all_cb_select').prop("checked",false);
        setProcessData({
            id: [],
            type: [],
            count: 0,
            order_amount: 0,
            settlement_fee: 0,
            settled_amount: 0,
            data: [],
            data2: []
        });

        
        $("#settlement_complete_form").find("input").val("");
        $("#settlement_complete_form").find("select").val("");

        setShowProcessDialog(false);
        checkStatusTopProcessButton();
    }

    const fileInput = useRef();
    const [attachment, setAttachment] = useState("");
    
    
    const handleChange = (e) => {
        const file = e.target?.files?.[0];

        if (!file) return;

        if (file.size > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");

            e.target.value = "";
            setAttachment(null);

            return;
        }

        setAttachment(file);
    };
    
    const processConfirm = async (event) => {
        event.preventDefault();
        
        if( companyProfile?.bank_account_name === "" ) {
            toast.error("No bank account is added for this company.");
            return;
        }

        let settlement_date = $("#settlement_date").val();
        if( settlement_date === "" ) {
            toast.error("Please enter settlement date.");
            return;
        }

        let transfer_from_bank = $("#transfer_from_bank").val();
        if( transfer_from_bank === "" ) {
            toast.error("Please choose transfer bank name.");
            return;
        }

        let ref_no = $("#ref_no").val();
        if( ref_no === "" ) {
            toast.error("Please enter ref no.");
            return;
        }

        if( attachment === null || attachment === undefined || attachment === "" ) {
            toast.error("Please upload an attachment.");
            return;
        }


        processData["settlement_date"] = settlement_date;
        processData["transfer_from"] = transfer_from_bank;
        processData["transfer_from_name"] = $("#transfer_from_bank").find(":selected").text();
        processData["transfer_to"] = companyProfile?.bank_account_name + "("+companyProfile?.bank_account_number+"), " + companyProfile?.bank_name + "("+companyProfile?.bank_branch_name+"), Routing No: "+companyProfile?.bank_routing;
        processData["ref_no"] = ref_no;
        processData["remarks"] = $("#remarks").val() ?? "";

        $("#settlement_complete_form").find("button[type='submit']").html("Processing...");
        $("#settlement_complete_form").find("button[type='submit']").attr("disabled",true);

        try {

            let requestBody = new FormData();

            requestBody.append("count", processData["count"]);
            processData.data.forEach((item, index) => {
                requestBody.append(`data[${index}]`, item);
            });

            processData.data2.forEach((item, index) => {
                requestBody.append(`data2[${index}]`, item);
            });

            processData.id.forEach((item, index) => {
                requestBody.append(`id[${index}]`, item);
            });

            requestBody.append("order_amount", processData["order_amount"]);
            requestBody.append("ref_no", processData["ref_no"]);
            requestBody.append("remarks", processData["remarks"]);
            requestBody.append("settled_amount", processData["settled_amount"]);
            requestBody.append("settlement_date", settlement_date);
            requestBody.append("settlement_fee", processData["settlement_fee"]);
            requestBody.append("transfer_from", transfer_from_bank);
            requestBody.append("transfer_from_name", processData["transfer_from_name"]);
            requestBody.append("transfer_to", processData["transfer_to"]);
            requestBody.append("type", processData["type"]);
            requestBody.append("attachment", attachment);


            await PostLoginPostApi("settlement/ready-for-process-complete-submit", requestBody, 1, 1).then((responseJSON) => {
                let response = JSON.stringify(responseJSON);
                response = JSON.parse(response);
    
                if(response["status"] === 1) {
                    let responseData = JSON.stringify(response["data"]);
                    responseData = JSON.parse(responseData);
    
                    if (responseData["code"] === 200) {
                        sendEmail(processData);
                        setTimeout(() => {
                            sendEmail(processData, true);
                        }, 1000);
                        completeExcelDownload(processData);
                        closeProcessBox();
                        toast.success(responseData["messages"] ?? "Settlement Complete.");
                        setRefreshCounter((prev)=>prev+1);
                        return;
                    }

                    toast.error(responseData["messages"].toString());
                }
            }).catch((err) => {
                console.log(err);
            }).then(()=>{
                $("#settlement_complete_form").find("button[type='submit']").html("Confirm Settlement");
                $("#settlement_complete_form").find("button[type='submit']").attr("disabled",false);
            });
        }
        catch(ex) {
            toast.error("A problem occur. Please try again.");
            console.log(ex);
        }
        
            
        return false;
    }


    const sendEmail = async (__processData, sendToAdmin = false) => {
        try {

            let reqData = {};
            reqData["email"] = sendToAdmin ? process.env.REACT_APP_ADMIN_EMAIL : companyProfile?.poc_email;
            reqData["ref_no"] = __processData?.ref_no;
            reqData["name"] = companyProfile?.name;
            reqData["date"] = moment(__processData?.settlement_date).format('DD MMM, YYYY');
            reqData["acc_from"] = __processData?.transfer_from_name;
            reqData["acc_to"] = __processData?.transfer_to;
            reqData["remarks"] = __processData?.remarks;
            reqData["no_of_orders"] = __processData?.count ?? 0;
            reqData["charge_amount"] = __processData?.settlement_fee ?? 0;
            reqData["total_amount"] = __processData?.order_amount ?? 0;
            reqData["payable"] = __processData?.settled_amount ?? 0;

            await PostLoginPostApi("settlement/confirmation-email", JSON.stringify(reqData)).then((responseJSON) => {
                let response = JSON.stringify(responseJSON);
                response = JSON.parse(response);
    
                if(response["status"] === 1) {
                    let responseData = JSON.stringify(response["data"]);
                    responseData = JSON.parse(responseData);
    
                    if (responseData["code"] === 200) {
                        console.log("Email send successfully.");
                        return;
                    }
                    
                    console.log(responseData["messages"].toString() ?? "");
                }
            }).catch((err) => {
                console.log(err);
            });
        }
        catch(ex) {
            toast.error("A problem occur. Please try again.");
            console.log(ex);
        }
        
            
        return false;
    }

    const excelDownload = () => {
        try {
            let i = 0;
            let arr = [];
    
            arr[i++] = ["#","Debit Account No (Transferred From)",  "Email /Voucher No (Empty)", "Batch No", "Beneficiary Name (Partner Bank A/C Name)", "Credit Account  (Partner Bank A/C Number)", "Txn Type", "Bank Name (Partner Bank Name)", "Bank Branch Name (Partner Bank Branch)", "Routing No  (Partner Bank Routing Number)", "Order Id", "Quantity", "Order Amount", "Settlement Fee", "Net Price", "Trade Price", "Settlement Type", "Remarks", "\r\n"];
            
    
            processData?.data?.map((val, index)=> 
                arr[i++] = [++index,"",  "", "", companyProfile?.bank_account_name, companyProfile?.bank_account_number + "'", "", 
                companyProfile?.bank_name, companyProfile?.bank_branch_name, companyProfile?.bank_routing + "'", val[0], val[6], val[3], val[4], val[5], val[8], val[7], "", "\r\n"]
            );
            
    
            // Prepare CSV and Download
            var blob = new Blob(arr, {type: "octet/stream"});
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            
            link.href = url;
            link.setAttribute(
                'download',
                `settlement-process-list_from_complete_${moment.now("Y-m-d")}.csv`,
            );
            
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
        catch(ex) {
            toast.error("A problem occur while downloading the excel file.");
            console.log(ex);
        }
    }



    const completeExcelDownload = (__processData) => {
        try {
            let i = 0;
            let arr = [];
    
            arr[i++] = ["#","Settlement Date","Debit Account No (Transferred From)",  "Transaction Ref. no", "Beneficiary Name (Partner Bank A/C Name)", "Credit Account  (Partner Bank A/C Number)", "Txn Type", "Bank Name (Partner Bank Name)", "Bank Branch Name (Partner Bank Branch)", "Routing No  (Partner Bank Routing Number)", "Order Id", "Quantity", "Order Amount", "Settlement Fee", "Net Price", "Trade Price", "Settlement Type", "Remarks", "\r\n"];
            
    
            __processData?.data?.map((val, index)=> 
                arr[i++] = [++index, __processData?.settlement_date, __processData?.transfer_from_name, __processData?.ref_no, companyProfile?.bank_account_name, companyProfile?.bank_account_number + "'", "", companyProfile?.bank_name, companyProfile?.bank_branch_name, companyProfile?.bank_routing + "'", val[0], val[6], val[3], val[4], val[5], val[7], val[8] ,__processData?.remarks, "\r\n"]
            );
            
    
            // Prepare CSV and Download
            var blob = new Blob(arr, {type: "octet/stream"});
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            
            link.href = url;
            link.setAttribute(
                'download',
                `settlement-process-complete-list_${moment.now("Y-m-d")}.csv`,
            );
            
            document.body.appendChild(link);
            link.click();
            link.remove();
        }
        catch(ex) {
            toast.error("A problem occur while downloading the excel file.");
            console.log(ex);
        }
    }

   


    // const [branchList, setBranchList] = useState([]);
    // const selectBank = () => {
    //     let bank_id = $("#transfer_from_bank").val();
    //     if( bank_id === "" || bank_id <= 0) {
    //         setBranchList([]);
    //         return;
    //     }

    //     // call api for branch based on bank 
    //     PostLoginPostApi("branches", JSON.stringify({bank_id: bank_id}), 4).then((responseJSON) => {
    //         let response = JSON.stringify(responseJSON);
    //         response = JSON.parse(response);

    //         if (response["status"] === 1) {
    //             let responseData = JSON.stringify(response["data"]);
    //             responseData = JSON.parse(responseData);

    //             if (responseData["code"] === 200) {
    //                 setBranchList(responseData["data"]);
    //                 $("#transfer_from_bank_branch").val("").change();
    //                 $("#transfer_from_bank_branch").focus();
    //             }
    //         }
    //     }).catch((err) => {
    //         console.log(err);
    //     });
    // }


    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }

    return (
        <div className="custom-container w-full font-montserrat flex">

            {/** Left Side */}
            <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full pr-3 pb-20 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                <div className="text-justify rounded-[5px] pb-2 pt-0">
                    <div className="w-1/2 float-left">
                        <h6 className="text-xl px-4 font-medium pb-0 pl-0 pt-5 mb-5">Here’s your pending settlement process lists at a glance</h6>
                        {/* <h6 className='text-lg font-medium mb-5'>Today</h6> */}
                    </div>



                    <div className="w-1/2 h-[68px] float-left text-right justify-end flex items-center">

                        <button type="button" onClick={processDialog} id="top_process_btn" className="mr-3 text-md border-[#00D632] border-2 rounded hover:bg-[#00D632] hover:text-white hidden" style={{padding: "9px 20px"}}>
                            Complete Settlement
                        </button>

                        
                        <CSVLink className="custom-btn mr-2 text-center" filename={"settlement-process-report.csv"} data={orderList}>
                            Export CSV
                        </CSVLink>

                        <Link to="#" onClick={filterClick} className="custom-btn filter text-center w-[92px]">Filter</Link>
                        <svg id="filter-toggle-icon" className='static -ml-4' width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="#1A202C" />
                            <path d="M17 19L13 15L17 11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#F5F5F5" />
                        </svg>
                    </div>
                </div>


                <div className="w-full flex overflow-hidden text-left pt-2">
                
                    {/* <div className="box hover-black-green w-1/4 py-5 h-auto bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Unsettled Order
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{summary.total ?? 0}</h3>
                    </div>

                    <div className="box hover-black-green w-1/4 py-5 h-auto ml-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Order Amount
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{process.env.REACT_APP_CURRENCY_SYMBOL} {summary.order_amount ?? 0}</h3>
                    </div>

                    <div className="box hover-black-green w-1/4 py-5 h-auto ml-[1%]  bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Amount After Settlement
                        </Link>

                        <h3 style={{ "fontSize": "22px" }} className="font-semibold  opacity-70">{process.env.REACT_APP_CURRENCY_SYMBOL} {summary.total_settled_amount ?? 0}</h3>
                    </div>

                    <div className="box hover-black-green w-1/4 py-5 h-auto ml-[1%] bg-[#FFFFFF] border-2 border-[#F5F5F5] text-[#222222] rounded-[5px] px-5">
                        <Link to="#" className="block text-base font-medium">
                            Total Fee
                        </Link>

                        <h3 style={{ fontSize: "22px" }} className="font-semibold  opacity-70">{process.env.REACT_APP_CURRENCY_SYMBOL} {summary.fee_amount ?? 0}</h3>
                    </div> */}



                </div>


                {/* DATA TABLE */}
                <div className="flex flex-col w-full">
                    <div className='-m-1.5 overflow-x-auto pt-0'>
                        <div className='p-1.5 min-w-full inline-block align-middle'>
                            <div className="border rounded-lg shadow overflow-hidden">
                                <table className="min-w-full divide-y divide-gray-200 custom-table-hover">
                                    <thead className='bg-neutral-100'>
                                        <tr className='text-left'>
                                            <th scope="col" className="px-4 py-3 text-center">
                                                <input type="checkbox" id="all_cb_select" onClick={selectAllCheckBox} />
                                            </th>
                                            <th scope="col" className="px-2 py-3 text-sm">Transaction ID & <br/>Date Time</th>
                                            <th scope="col" className="px-3 py-3 text-sm text-center" title="Quantity">Qty</th>
                                            <th scope="col" className="px-4 py-3 text-sm text-center">Order <br/>Amount (A)</th>
                                            <th scope="col" className="px-4 py-3 text-sm text-center">Settlement <br/>Fee (B)</th>
                                            <th scope="col" className="px-4 py-3 text-sm text-center">Net Price <br/>(A-B)</th>
                                            <th scope="col" className="px-4 py-3 text-sm text-center">Trade <br/>Price</th>
                                            <th scope="col" className="px-4 py-3 text-sm text-center">Settlement <br/>Type</th>
                                            <th scope="col" className="px-4 py-3 text-sm text-center">Service</th>
                                            <th scope="col" className="px-3 py-3 text-sm">Process Info</th>
                                            <th scope="col" className="px-3 py-3 text-sm">Process <br/>Remarks</th>
                                            <th scope="col" className="px-6 py-3 text-sm text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className='divide-y divide-gray-200'>

                                        {orderList.map((val, index)=> (
                                            (val !== null) &&

                                            <tr key={index}>
                                                <td className='py-2 text-center border-r-2 font-semibold cursor-pointer' onClick={()=>checkBoxEnable(index)}>
                                                    <input className="order_cb" name="order_cb" type="checkbox" id={`cb_order_${index}`} 
                                                    onClick={()=>checkBoxEnable2(index)} readOnly={true} value={index} />

                                                    <input type="hidden" value={val.id} name="order_id" className="order_id" />
                                                    <input type="hidden" value={val.booking_code} name="order_transaction_no" className="order_transaction_no" />
                                                    <input type="hidden" value={val.quantity} name="order_quantity" className="order_quantity" />
                                                    <input type="hidden" value={val.order_amount} name="order_amount" className="order_amount" />
                                                    <input type="hidden" value={val.settlement_fee} name="order_fee" className="order_fee" />
                                                    <input type="hidden" value={val.payable} name="order_payable" className="order_payable" />
                                                    <input type="hidden" value={val.trade_price} name="trade_price" className="trade_price" />
                                                    <input type="hidden" value={val.service_type} name="order_type" className="order_type" />
                                                    <input type="hidden" value={val.settlement_on} name="settlement_on" className="settlement_on" />
                                                </td>
                                                
                                                <td style={{textAlign: "left"}} className='text-sm px-2 py-2 border-r-2'>
                                                    {(val.service_type === "shop") ? 
                                                        <Link to={`/dashboard/orders/order-invoice/${val.shop_order_id}?source=settlement`} target={"_blank"} className='cursor-pointer text-[#0774E9] font-bold'>{val.booking_code ?? ""}</Link>
                                                    :
                                                        <span>{val.booking_code ?? ""}</span> 
                                                    }
                                                    <br/>{moment(val?.booked_product?.createdAt).format("DD MMM, YYYY hh:mm A")}
                                                </td>
                                                <td className='text-sm px-3 py-2 border-r-2 text-center'>{val.quantity ?? "-"}</td>
                                                <td className='text-sm px-4 py-2 border-r-2 text-center'>{number_format(val.order_amount,2) ?? 0}</td>
                                                <td className='text-sm px-4 py-2 border-r-2 text-center'>{number_format(val.settlement_fee ?? 0,2)}</td>
                                                <td className='text-sm px-4 py-2 border-r-2 text-center'>{number_format(val.payable ?? 0, 2)}</td>
                                                <td className='text-sm px-4 py-2 border-r-2 text-center'>{number_format(val.trade_price,2) ?? 0}</td>
                                                <td className='text-sm px-4 py-2 border-r-2 text-center'>{val?.settlement_on ?? "-"}</td>
                                                <td className='text-sm px-4 py-2 border-r-2 text-center'>{val.service_type[0].toUpperCase()+ val.service_type.slice(1)}</td>
                                                <td style={{textAlign: "left"}} className='text-sm px-3 py-2 border-r-2'>
                                                    {moment(val.created_at).format("DD MMM, YYYY hh:mm A")}<br/>
                                                    {val.created_by?.name}
                                                </td>
                                                <td style={{textAlign: "left"}} className='text-sm px-3 py-2 border-r-2'>{val.remarks}</td>
                                                <td className='px-3 py-2 text-center'>
                                                    <button type="button" onClick={()=>processDialogSingle(val.id, val.order_amount, val.settlement_fee, val.payable, val.service_type, val.booking_code, val.quantity, val.settlement_on, val.trade_price)} className="process_button_single text-sm px-2 py-0.5 border-[#00D632] border-2 rounded font-semibold hover:bg-[#00D632] hover:text-white disabled:opacity-30 disabled:cursor-not-allowed">Complete</button>
                                                </td>
                                            </tr>
                                        ))}
                                        
                                        
                                    </tbody>
                                </table>

                            </div>

                            <>
                            
                                <p className='text-center w-full mt-5'>
                                    Total <b>{orderList.length ?? 0}</b> records found
                                </p>

                            </>

                        </div>
                    </div>
                </div>
            </div>

            {/* Process Dialog */}
            {(showProcessDialog === true) &&
                <div>
                    <Popup content={
                        <form id="settlement_complete_form" className="p-5 font-medium" onSubmit={(e)=>processConfirm(e)}>
                            <div className="flex justify-between">
                                <h3 className="text-lg text-black font-semibold">Settlement Process Complete</h3>
                                <CloseBtn className="cursor-pointer" onClick={closeProcessBox} />
                            </div>

                            <div className='max-w-lg mt-6 pr-1 whitespace-break-spaces'>
                                <table className="custom-details-table w-full mt-0 mb-2">
                                    <tbody>
                                        <tr>
                                            <td className="font-semibold text-base">Amount</td>
                                            <td className="px-5 text-base">
                                                <div className='flex items-center'>{process.env.REACT_APP_CURRENCY_SYMBOL} {number_format(processData.order_amount ?? 0,2)}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold text-base">Settlement Fee</td>
                                            <td className="px-5 text-base">
                                                <div className='flex items-center'>{process.env.REACT_APP_CURRENCY_SYMBOL} {number_format(processData.settlement_fee ?? 0,2)}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold text-base">Settled Amount</td>
                                            <td className="px-5 text-base">
                                                <div className='flex items-center'>{process.env.REACT_APP_CURRENCY_SYMBOL} {number_format(processData.settled_amount ?? 0, 2)}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold text-base">Transaction Count</td>
                                            <td className="px-5 text-base">
                                                <div className='flex items-center'>{processData.count}</div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="font-semibold text-base">Process Excel</td>
                                            <td className="px-5 text-base">
                                                <div className='flex items-center'>
                                                    <Link to={"#"} onClick={excelDownload} className="text-sm px-3 py-0.5 border-[#00D632] border-2 rounded font-semibold hover:bg-[#00D632] hover:text-white disabled:opacity-30 disabled:cursor-not-allowed">
                                                        Download Process Excel
                                                    </Link>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>


                                <div className="relative pb-2 pt-1 mb-0 mt-4">
                                    <select name="transfer_from_bank" id="transfer_from_bank" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required>
                                        <option value="">Choose Transferred From</option>
                                        {bankList.map((data, index) => (
                                            <option key={index} value={data.id} className='text-black'>{data.name}</option>
                                        ))}
                                    </select>

                                    <label htmlFor="transfer_from_bank" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Transferred From Bank Name *</label>
                                </div>

                                <div className="flex mt-1 pt-1">
                                    <div className="relative pb-2 pt-1 mb-1 w-1/3">
                                        <input type="date" name="settlement_date" id="settlement_date" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" min={moment().subtract(7, "days").format("YYYY-MM-DD")} required />

                                        <label htmlFor="settlement_date" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Settlement Date *</label>
                                    </div>
                                    <div className="relative pb-2 ml-2 pt-1 mb-1 mt-0 w-full">
                                        <input type="text" name="ref_no" id="ref_no" placeholder=" " className="w-full rounded border-solid border border-dark-white pl-2 placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" maxLength={25} required />

                                        <label htmlFor="ref_no" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Reference Id *</label>
                                    </div>
                                </div>

                                
                                <div className="relative pb-2 pt-0 mb-0 mt-0">
                                    <input
                                        type="file"
                                        name="attachment"
                                        id="attachment"
                                        className="
                                        block w-full text-sm text-gray-700 dark:text-gray-200
                                        border border-gray-300 dark:border-gray-600
                                        rounded-lg cursor-pointer
                                        bg-white dark:bg-gray-900
                                        focus:outline-none focus:ring-0
                                        "
                                        ref={fileInput}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>

    
                                <div className="relative pb-2 mb-1 mt-2">
                                    <textarea name="remarks" id="remarks" placeholder="Remarks (optional)" className="w-full resize-none h-20 rounded border-solid border border-dark-white pl-2 placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" max={300} />      
                                </div>

                                <button type="submit" className="mt-2 mb-2 w-full py-1.5 text-md font-semibold border-[#00D632] border-2 rounded bg-[#00D632] text-white hover:bg-white hover:text-[#00D632] disabled:bg-gray-400 disabled:text-white disabled:border-[#CCC] disabled:cursor-wait">
                                    Confirm Settlement
                                </button>
                            
                            </div>

                        </form>}
                    />
                </div>
            }
            {/* Process Dialog End */}

            {/* Right Side */}
            <div id="filter-div" className="custom-container-right float-right w-1/5 pl-2 pb-10 pt-4 pr-1 justify-center custom-scroll-auto mb-20 no-need-without-shadow">
                <div className="relative">
                    <h6 className="text-lg px-3 font-base pb-2 pl-2" style={{ boxShadow: "0 3px 0 0 rgb(0 0 0 / 1%)" }}>Filter Settlement</h6>

                    <div className="box-full w-full  text-justify py-2 pl-2 pr-1">
                        <div className="w-full float-left pt-2">
                            <select onChange={setDatePicker} id="date-range-data" className='w-full mt-0 mb-4 bg-[#F5F5F5] rounded border-0' defaultValue="custom">
                                <option value="all">Single Date</option>
                                <option value="custom">Date Range</option>
                            </select>
                            <DatePickerV2 />
                            <DatePickerRange />
                        </div>
                    </div>
                    
                    <div className="box-full block w-full h-full text-justify pl-2">
                        <div className="w-full float-left pb-1 pt-5">
                            <select id="service_type" className='w-full mt-0 mb-4 bg-[#F5F5F5] rounded border-0'>
                                <option value="all">Service Type</option>
                                <option value="shop">Shop</option>
                                <option value="voucher">Voucher</option>
                            </select>
                        </div>
                    </div>

                    <div className="box-full flex w-[97%] h-full text-justify py-0.5 px-0.5 ml-2 mt-5 mb-6 bg-[#F5F5F5] rounded">
                        <div className="w-full h-full float-left">
                            <input type="text" id="search-by-transaction-id" name="search-by-transaction-id" autoComplete='off' className="custom-search-fields w-full text-base border-0 rounded placeholder:text-ash" placeholder='Search by Transaction ID' />

                        </div>
                    </div>


                    <button onClick={filter} className="custom-btn w-[97%] flow-root float-left ml-2 mt-2">Filter</button>
                    {isFilter && <button onClick={resetFilterData} className="custom-btn ml-2 mt-3 flow-root w-[97%] float-left bg-black text-white border-black" style={{ color: "#FFF" }}>Reset Filter</button>}

                </div>
            </div>
        </div>
    );


};

export default SettlementComplete;